import { DisplayAmount, WhiteBoxBlock } from "ui";
import styles from "./rubBalance.module.css";
import { Flex, Typography } from "antd";
import { BidEntity, TOKEN_BALANCE_ENUM } from "interfaces";
import { ReactComponent as RubIcon } from "images/coins/rub.svg";

interface RubAmountBlockProps {
  bid: BidEntity;
}

export const RubBalanceBlock = ({ bid }: RubAmountBlockProps) => {
  const { rubBalance } = bid;
  return (
    <WhiteBoxBlock className={`bg-basic-200 full-width ${styles.rubBalanceBlockPadding}`}>
      <Flex align="center" gap="small">
        <RubIcon />
        <Flex vertical>
          <Typography.Text className={styles.rubBalanceText}>Рублевый баланс на заявке</Typography.Text>
          <DisplayAmount amount={+rubBalance} currency={TOKEN_BALANCE_ENUM.RUB as string} isCurrencyGrey />
        </Flex>
      </Flex>
    </WhiteBoxBlock>
  );
};
